function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useElementSize } from '@bydesign-ui/hooks';
import { RcPopper } from '../../../hooks/popper';
import { useRegion, useRegionClick } from '../../../hooks/region';
import { classnames } from '@bydesign-ui/utils';
import React, { memo, useRef } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { ColorDragger } from './ColorDragger';
export var ColorSlider = memo(function (props) {
  var disabled = props.disabled,
      _props$dimension = props.dimension,
      dimension = _props$dimension === void 0 ? 'one' : _props$dimension,
      className = props.className,
      children = props.children,
      extra = _objectWithoutProperties(props, ["disabled", "dimension", "className", "children"]);

  var region = useRegion();
  var containerRef = useRef(null);
  var onClick = useRegionClick(containerRef);
  useElementSize(containerRef, function () {
    return true;
  }, function (size) {
    region.updateRegionSize({
      width: size.width,
      height: size.height
    });
  });
  var cls = classnames(usePrefixCls('color-slider', _defineProperty({}, dimension, true)), className);
  var innerCls = usePrefixCls('color-slider-inner', _defineProperty({}, dimension, true));
  return React.createElement(RcPopper, null, React.createElement("div", Object.assign({
    className: cls
  }, extra), children, React.createElement("div", {
    className: innerCls,
    onClick: onClick,
    ref: containerRef
  }), React.createElement(ColorDragger, {
    dimension: dimension,
    draggable: !disabled,
    name: "end"
  })));
});